import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { TronWalletProvider } from '../TronWalletProvider.types';

export const isTronWalletProvider = (
  provider: WalletProvider | TronWalletProvider
): provider is TronWalletProvider => {
  return provider.chain === 'TRON';
};
